import React from 'react';
import { DOCTOR_PHOTO } from '../../data/content';
import { SectionCta } from '../SectionCta';
export function About() {
  return <section className="bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-63" data-mp="oqm6vv6u8fk5">
      <div className="mx-auto max-w-5xl" data-id="element-64" data-mp="12rf2ykcsfipd">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-teal-600" data-id="element-65" data-mp="12q40cnv2wgzu">
          🏥 About Dr. Karito
        </p>

        <div className="mt-8 grid items-start gap-8 lg:grid-cols-[minmax(0,320px)_1fr]" data-id="element-66" data-mp="azhbx6ef0bg5">
          <figure className="mx-auto w-full max-w-[320px]" data-id="element-67" data-mp="60wd9bet9ztt">
            <img src={DOCTOR_PHOTO} alt="Dr. Karito, physician and creator of the GLP-1 Decision Map" className="w-full rounded-3xl object-cover" width={640} height={960} loading="lazy" data-id="element-68" data-mp="62h8z4cv3ot9" />
            <figcaption className="mt-3 text-center font-display text-xl font-bold text-navy-800" data-id="element-69" data-mp="3nftc2s0hjmob">
              Dr. Karito
            </figcaption>
          </figure>

          <div data-id="element-70" data-mp="339ry5pd70ph0">
            <h2 className="font-display text-[26px] font-bold leading-tight text-navy-800 sm:text-4xl" data-id="element-71" data-mp="3387400usj8jo">
              The problem was never a lack of information.{' '}
              <em className="italic text-teal-600" data-id="element-72" data-mp="3czbikzgk0rdz">There was too much of it.</em>
            </h2>

            <div className="mt-5 flex flex-col gap-4 text-[15px] leading-relaxed text-navy-700/85 sm:text-base" data-id="element-73" data-mp="3hxv5p36vw97x">
              <p data-id="element-74" data-mp="2kaw72mwmsr7e">
                For years, Dr. Karito observed a growing challenge among physicians incorporating
                GLP-1 therapies into their practice: guidelines, articles, updates, clinical
                resources, notes, questions — all scattered in different places.
              </p>
              <p data-id="element-75" data-mp="2z7wvohjj061n">
                The real challenge was knowing how to organize all that information when the patient
                was sitting right in front of you.
              </p>
              <p data-id="element-76" data-mp="egwe88145ijf">
                That's why she created GLP-1 Decision Map™. Not as another long course. Not as
                another PDF that gets lost in a folder. But as a visual system of maps, checklists,
                and professional tools designed to help physicians structure their consultations,
                identify what information needs to be verified, and work through a more organized
                process.
              </p>
            </div>

            <blockquote className="mt-6 rounded-2xl border-l-4 border-teal-500 bg-white p-5" data-id="element-77" data-mp="2fhszin8fhv0a">
              <p className="font-display text-lg italic leading-snug text-navy-800 sm:text-xl" data-id="element-78" data-mp="1rrotyabojl6n">
                "You don't need to memorize everything. You need to know what to review, in what
                order, and where to verify it."
              </p>
              <footer className="mt-3 text-[13px] font-bold uppercase tracking-wide text-teal-600" data-id="element-79" data-mp="1vuuxvbbbl09y">
                — Dr. Karito
              </footer>
            </blockquote>
          </div>
        </div>

        <SectionCta label="I want Dr. Karito's system" data-id="element-80" data-mp="143p1n5ypzmpy" />
      </div>
    </section>;
}